import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import JoinTheExpedition from "./sections/JoinTheExpedition";
import OurStation from "./sections/OurStation";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <JoinTheExpedition />
      <OurStation />
      <CommonQuestions />
      <Footer />
    </div>;
}